<div [class.ds-focus]="hasFocus"
     [class.ds-disabled]="isDisabled"
     [class.form-control--addition]="iconName"
     [class.ds-invalid]="showError"
     [class.d-none]="isReadOnly"
     [class.d-flex]="!isReadOnly"
     class="form-control date-picker justify-content-between px-2"
>
  <input
    #innerInput
    [(ngModel)]="innerValue"
    (ngModelChange)="onChange(innerValue)"
    [id]="inputID"
    (blur)="setHasFocus(false);onTouch()"
    (focus)="setHasFocus(true)"
    [attr.aria-describedby]="errorMessageID"
    class="form-control--input p-0 date-picker-input"
    [class.ds-cursor--not-allowed]="isDisabled"
    [firstDayOfWeek]="7"
    [dayTemplate]="customDay"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [markDisabled]="markDisabled"
    [disabled]="isDisabled"
    [placeholder]="placeholder"
    ngbDatepicker
    #dp="ngbDatepicker"
  />
  <em
    [attr.aria-hidden]="true"
    [class.ds-cursor--not-allowed]="isDisabled"
    (click)="open()"
    (keydown.enter)="handleKeyInput()"
    class="ds-icon ds-icon--big ds-icon--calendar ds-color--{{isDisabled ? 'grey-2' : 'blue'}} ms-1 focusable focusable__element"
    tabindex="0"
  >
  </em>

  <label
    class="form-control-label ds-fine-print form-control-label__text"
    [attr.aria-hidden]="true"
    [for]='inputID'>
    {{label}}
  </label>
</div>

<div *ngIf="isReadOnly" class="d-flex justify-content-between {{readOnlyCssClass}}">
    <span>{{readOnlyLabel}}
      <span class="ds-font--medium">
        {{formattedMinDate}}
      </span>
    </span>
</div>

<ds-input-error
  [id]="errorMessageID"
  [error]="error"
  [showError]="showError">
</ds-input-error>

<ng-template #customDay let-date="date" let-currentMonth="currentMonth"
             let-selected="selected" let-disabled="disabled">
  <div class="custom-day"
       [class.currentDay]="isToday(date)"
       [class.bg-primary]="selected"
       [class.outsideDays]="date.month !== currentMonth"
       [class.text-muted]="disabled"
       [class.ds-cursor--not-allowed]="isDisabled"
  >
    {{ date.day }}
  </div>
</ng-template>


